import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

export const getMutedUserQuery = gql`
  query MutedUserQuery($muteeId: String!) {
    MutedUsers(where: { mutee: { equals: $muteeId } }) {
      docs {
        id
        mutee {
          id
          fullName
        }
        createdAt
      }
    }
  }
`

export interface MutedUsersQueryInput {
  muteeId: string
}

export interface MutedUsersQueryOutput {
  MutedUsers: {
    docs: {
      id: string
      mutee: {
        id: string
        fullName: string
        avatar?: {
          url: string
        }
      }
      createdAt: string
    }[]
  }
}

export const useMutedUserQuery = (
  options: QueryHookOptions<MutedUsersQueryOutput, MutedUsersQueryInput>
) => usePersistedCacheQuery<MutedUsersQueryOutput, MutedUsersQueryInput>(getMutedUserQuery, options)
